import { Message, MessageContentDataBlank } from "../../model/message";

export default function isGroupLast(message: Message<MessageContentDataBlank>, nextMessage?: Message<MessageContentDataBlank>) {

    // 消息在1分钟以内，并且是自己发的消息
    return !nextMessage ||
        message.owner.id !== nextMessage.owner.id ||
        (message.insertedAt.add(1, "minutes").isBefore(nextMessage.insertedAt))
}